<!--
Description
adds a upload button to a form
returns the filename (including the simple uid) and the downloadUrl (callback from FirebaseStorage after uploading)

Usage
put <Storage path="downloads/" v-on:setUrl='setUrl' v-on:setFilename="setFilename" imageOnly></Storage> where you need it to add a upload button
@prop path: the path in firebase Storage to store the file (it will be: path/companyUid/filename)
@prop imageOnly: add to the html tag to allow only images to be uploaded. if ommitted then everything is accepted
@prop noPreview: do not show the loaded picture
@event setUrl: @var downloadUrl: change the state of the String downloadUrl (callback from firebase storage)
@event setFilename: @var fileName: change the state of the String fileName (used to relocate it in fb storage for delete purpose and also to extract the filetype)
@prop initialPic: url of a picture to show when called
@prop initialFilename: file to display on edit

To prevent duplicate filenames a simple uid is attached at te start of the filename: [9characters]_filename

It also handles deletion of the file when clicked on the 'delete' button
When the form is cancelled, be sure to delete the file in the parent component by path/filename.

TODO
initialPic delete this form storage when changing this picture

-->
<template>
  <div>
    <button
      class="btn btn-info mb-5 btn-sm"
      @click="selectFile"
      v-if="((!noPreview && !uploadEnd && !uploading) || (noPreview && !uploading)) && !icon"
    ><span v-if="imageOnly">Afbeelding</span><span v-if="!imageOnly">Bestand</span> kiezen</button>
        <button title="afbeelding wijzigen"
      class="btn btn-info btn-sm"
      @click="selectFile"
      v-if="((!noPreview && !uploadEnd && !uploading) || (noPreview && !uploading)) && icon"
    ><svg class="bi bi-image" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="M14.002 2h-12a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-12-1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12z"/>
  <path d="M10.648 7.646a.5.5 0 0 1 .577-.093L15.002 9.5V14h-14v-2l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71z"/>
  <path fill-rule="evenodd" d="M4.502 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
</svg></button>
    <form ref="form">
      <input v-if="imageOnly"
        id="files"
        type="file"
        name="file"
        ref="uploadInput"        
        accept="image/*"
        :multiple="false"
        @change="detectFiles($event)"
      />

      <input v-if="!imageOnly"
        id="files"
        type="file"
        name="file"
        ref="uploadInput"    
        :multiple="false"
        @change="detectFiles($event)"
      />


    </form>

    <img v-if="uploadEnd && imageOnly && !noPreview" :src="downloadURL" width="400" />
    <img v-if="!uploadEnd && imageOnly && !noPreview  && (initialPic!= null && initialPic!='')" :src="initialPic" width="400" />
 
  <div v-if="!uploadEnd && initialFilename!='' "><span v-if="!imageOnly">Bestandsnaam: </span><span>{{initialFilename}}</span><br><br></div>
    <div v-if="uploadEnd && !noPreview">
      <button
        class="btn btn-small btn-danger m-2 mb-5"
        dark
        small
        color="error"
        @click="deleteImage()"
      ><span v-if="imageOnly">Afbeelding</span><span v-if="!imageOnly">Bestand</span> verwijderen</button><span>{{fileName}}</span>
    </div>
  </div>
</template>

<script>

const fb = require("@/firebaseConfig.js");
var firestorage = fb.firestorage;

export default {
  name: "Storage",
  data() {
    return {
      progressUpload: 0,
      fileName: "",
      uploadTask: "",
      uploading: false,
      uploadEnd: false,
      downloadURL: "",
      imageUid: '',
    };
  },
  props: {
    path: String,
    imageOnly: Boolean,
    noPreview: Boolean,
    icon:Boolean,
    initialPic: String,
    initialFilename: String,
  },
  methods: {
    selectFile() {
      this.$refs.uploadInput.click();
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files;
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x]);
      });
    },
    upload(file) {
      this.fileName = file.name;
      this.uploading = true;
      var uid = this.imageUid
      this.uploadTask = firestorage.ref(this.path + this.$cookies.get("company") + "/" + uid + file.name).put(file);
           this.$emit('setFilename', uid + file.name)
    },
    deleteImage() {
      firestorage
        .ref(this.path + this.$cookies.get("company") + "/" + this.imageUid + this.fileName)
        .delete()
        .then(() => {
          this.uploading = false;
          this.uploadEnd = false;
          this.downloadURL = "";
        })
        .catch(error => {
          console.error(`file delete error occured: ${error}`);
        });
      this.$refs.form.reset();
    },
  },
    created () {
        this.imageUid = Math.random().toString(36).substr(2, 9) + '_'; 
    },
  watch: {
    uploadTask: function() {
      this.uploadTask.on(
        "state_changed",
        sp => {
          this.progressUpload = Math.floor(
            (sp.bytesTransferred / sp.totalBytes) * 100
          );
          console.log(sp)
        },
        null,
        () => {
          this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.uploadEnd = true;
          this.uploading = false;
            this.downloadURL = downloadURL;
            this.$emit("setUrl", downloadURL);
          });
        }
      );
    }
  }
};
</script>

<style>
.progress-bar {
  margin: 10px 0;
}
input[type="file"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
</style>